import React, { useEffect, useState, useRef } from 'react'
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import toWav from 'audiobuffer-to-wav';
import axios from 'axios';
import { useUserAuth } from "../../context/UserAuthContext";
import './WavRecorder.css';
import e from 'cors';

const WavRecorder = ({ onClose, onSaveAudio}) => {
    const [isRecordingWP, setIsRecordingWP] = useState(false);
    const [blobURL, setBlobURL] = useState('');
    const [isVisibleWavRrecorder, setIsVisibleWavRrecorder] = useState(false);
    const [audioBlob, setAudioBlob] = React.useState(null);

    useEffect(() => {
        setIsVisibleWavRrecorder(true);
        return () => {
            setIsVisibleWavRrecorder(false);
        };
    }, []);
    
    //recording audio
    const recorderControls = useAudioRecorder(
        {
            noiseSuppression: true,
            echoCancellation: true,
            channelCount: 1,
            sampleRate: 16000,
            sampleSize: 16,
        },
        (err) => console.table(err) // onNotAllowedOrFound  
        );
    
    const addAudioElement = (blob) => {
        setAudioBlob(blob);
        // console.log('audioBlob:', blob);
        setTimeout(() => {
            saveRecordingWavBlob(blob);
        }, 3);
        const url = URL.createObjectURL(blob);
        // const fileformat = 'wav';
        // const audio = document.createElement(`${nameSetbyTime(fileformat)}`);
        // audio.src = url;
        // audio.controls = true;
        setBlobURL(url);
        // document.body.appendChild(audio);
    };

    const handleRecordBtnClick = () => {
        if (isRecordingWP) {
            stopRecorder();
        } else {
            startRecorder();
        }
    }

    const startRecorder = () => {
        recorderControls.startRecording();
        setIsRecordingWP(true);
      };
    
    const stopRecorder = () => {
        recorderControls.stopRecording();
        setIsRecordingWP(false);
    };

    const skipRecorder = () => {
        // recorderControls.togglePauseResume();
        setIsVisibleWavRrecorder(false);
        onClose();
    };

    //save .wav file
    const saveRecordingWavBlob = async (blob) => {
        if (blob) {
            // Convert the audio blob to an AudioBuffer
            const arrayBuffer = await blob.arrayBuffer();
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    
            // Create an OfflineAudioContext with the desired output sample rate
            const offlineCtx = new OfflineAudioContext(audioBuffer.numberOfChannels, audioBuffer.duration * 16000, 16000);
    
            // Create a buffer source
            const bufferSource = offlineCtx.createBufferSource();
            bufferSource.buffer = audioBuffer;
    
            // Connect the source to the context
            bufferSource.connect(offlineCtx.destination);
    
            // Start the source
            bufferSource.start();
    
            // Render the audio and get the resulting buffer
            const resampledBuffer = await offlineCtx.startRendering();
    
            // Check the duration of the audio
            const duration = resampledBuffer.duration;
    
            // Convert the resampled audio buffer to WAV
            const wav = toWav(resampledBuffer, 1 );
    
            // Create a new blob from the WAV file
            const wavBlob = new Blob([new DataView(wav)], { type: 'audio/wav' });
            onSaveAudio(wavBlob, duration); 
    
            // // Create a URL for the blob
            // const url = URL.createObjectURL(wavBlob);
            // setBlobURL(url);
    
            // // Create a URL for the blob
            // const link = document.createElement('a');
            // link.href = url;
            // link.download = 'signature.wav'; // Custom filename
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // URL.revokeObjectURL(url); // Clean up
        } else {
            console.log('No audio to save');
        }
    };
    
    return (
        <div className={`popup-settingsnew-overlay ${isVisibleWavRrecorder ? 'active' : ''}`}>    
            <div className="popup-wavrecorder-container">
                <div className="popup-wavrecorder-header">
                    <p className="popup-wavrecorder-headtext">Voice Signature</p>
                    <span className="close-wavrecorder" onClick={onClose}>&times;</span>
                </div>

                <div className="popup-wavrecorder-body">
                    <AudioRecorder
                        onRecordingComplete={(blob) => addAudioElement(blob)}
                        recorderControls={recorderControls}
                        downloadOnSavePress={false}
                        downloadFileExtension="wav"
                        showVisualizer={true}
                    />
                    <p className="wavrecorder-p">In order to obtain more accurate AI assistance,  
                    please make continue half-minute brief self-introduction to warm up.</p>
                    <div className='wavrecorder-btn-container'>
                        <button className="wavrecorder_btn" 
                            onClick={handleRecordBtnClick} >
                            {isRecordingWP 
                                ? 'Stop'
                                : 'Start'
                            }
                        </button>
                        <button className="wavrecorder_btn" onClick={skipRecorder} disabled={isRecordingWP}>
                            {audioBlob !== null ? 'Done' : 'Skip'} 
                        </button>
                    </div>
                </div>   
            </div>
        </div>
    );
  };
  
export default WavRecorder;
  


